import * as z from "zod";
import { ProductResumeStateSchema } from "./get-resume-state";
import { PRODUCT_IDS } from "./initialize";

export const listResumeStates = {
  name: "listResumeStates" as const,
  input: z.object({}),
  output: z.object({
    products: z.partialRecord(z.enum(PRODUCT_IDS), ProductResumeStateSchema),
  }),
};
